// export const PLANSTATUS = {
//   UPLOADING: 'UPLOADING',      // 上传中
//   TRANSCODING: 'TRANSCODING',  // 转码中
//   UPLOAD_FAILED: 'UPLOAD_FAILED',    // 上传失败
//   TRANSCODE_FAILED: 'traTRANSCODE_FAILEDnscode_failed', // 转码失败
//   INVALID: 'INVALID',          // 无效视频
//   READY: 'READY',              // 准备下发
//   DEPLOYING: 'DEPLOYING',      // 下发中
//   DEPLOY_FAILED: 'DEPLOY_FAILED', // 下发失败
//   SUCCESS: 'SUCCESS',          // 下发完成
//   FULL: 'FULL',               // 场景已满
// };

export const PLANSTATUS = {
  AllSuccess: 1, //全部成功
  Invalid: 99, //无效
  Overflow: 4, //满了&& 溢出
  Configing: 0, //配置中
  SomeSuccess: 2, //部分成功
  Deploy_Failed: 3, // 下发失败
  UpLoading:5,//上传中，自定义的
  Upload_Failed:8,//上传失败，自定义的

  Pending : 91,               //准备转码 (视频场景状态)
  Transcoding :92,           //转码中 (视频场景状态)
  TranscodeCompleted : 93,    //转码完成 (视频场景状态)
  TranscodeFailed : 94,       //转码失败 (视频场景状态)
  NotSupportedVideo : 95,     //视频不支持转码 (视频场景状态)
}

export const STATUS_DISPLAY = {
  [PLANSTATUS.Pending] : '准备转码',  
  [PLANSTATUS.UpLoading]: '上传中...',
  [PLANSTATUS.Transcoding]: '转码中...',
  [PLANSTATUS.TranscodeCompleted]: '转码完成',
  [PLANSTATUS.Upload_Failed]: '上传失败',
  [PLANSTATUS.TranscodeFailed]: '转码失败',
  [PLANSTATUS.Invalid]: '该视频不支持',
  [PLANSTATUS.READY]: '未下发',
  [PLANSTATUS.Configing]: '配置中...',
  [PLANSTATUS.Deploy_Failed]: '下发失败',
  [PLANSTATUS.SUCCESS]: '下发完成',
  [PLANSTATUS.Overflow]: '场景已满',
}

//状态映射图标
export const STATUS_ICON = {
  [PLANSTATUS.UpLoading]: require('@/assets/img/tianmu/uploading.png'),
  [PLANSTATUS.Transcoding]: require('@/assets/img/tianmu/transcode.png'),
  [PLANSTATUS.Upload_Failed]: require('@/assets/img/tianmu/uploadFailure.png'),
  [PLANSTATUS.TranscodeFailed]: require('@/assets/img/tianmu/transcodeFailure.png'),
  [PLANSTATUS.NotSupportedVideo]: require('@/assets/img/tianmu/transcodeFailure.png'),
  [PLANSTATUS.Configing]: require('@/assets/img/tianmu/configIng.png'),
  [PLANSTATUS.Deploy_Failed]: require('@/assets/img/tianmu/configFailure.png'),
  [PLANSTATUS.Overflow]: require('@/assets/img/tianmu/overflow.png'),
  [PLANSTATUS.TranscodeCompleted]: require('@/assets/img/tianmu/unConfig.png'),
  [PLANSTATUS.Pending]: require('@/assets/img/tianmu/transcode.png'),
}

export const STATUS_PLAY_VIDEO = {
  Playing:0, //继续播放
  Pause:1, //暂停播放
  Stoped:2, //停止播放
}

export const STATUS_PLAY_VIDEO_TXT = {
  [STATUS_PLAY_VIDEO.Playing]:'设备播放中...',
  [STATUS_PLAY_VIDEO.Pause]:'已暂停',
  [STATUS_PLAY_VIDEO.Stoped]:''
}

export const STATUS_PLAY_VIDEO_ICON = {
  [STATUS_PLAY_VIDEO.Playing]:require('@/assets/img/tianmu/scenePlaying.png'),
  [STATUS_PLAY_VIDEO.Pause]:require('@/assets/img/tianmu/scenePause.png')
}


// 方案类别`
export const PLANTYPE = {
  System: 'System', // 系统
  Customize: 'Project', // 自定义
}
